import * as t from 'io-ts';
import { optional } from './helper';

const feedItem = t.type({
  feedId: t.string,
  itemType: t.string,
  datePublished: t.string,
  itemSubType: optional(t.string),
  relevance: t.number,
});
export type FeedItem = t.TypeOf<typeof feedItem>;

const pagination = t.type({
  continuationToken: optional(t.string),
});

const feedApi = t.type({
  feed: optional(t.array(feedItem)),
  pagination: optional(pagination),
});
export const feedApiResponse = feedApi;
export type Feed = t.TypeOf<typeof feedApiResponse>;
